import React from 'react';
import { WorkoutStructureBar } from '../../components/workout/WorkoutStructureBar';
import type { ApiStructBlock } from '../../utils/workoutStructure';
import type { PrimaryIntensityMetric } from '../../utils/workoutBuilderSettings';
import type { StructureStepThresholds } from './WorkoutStructureSteps';

/** Full-width structure preview bar — zone-colored bars (matches builder / web). */
export function WorkoutStructureBarPreview({
  structure,
  intensityThresholds,
}: {
  structure: {
    structure?: ApiStructBlock[];
    primaryLengthMetric?: string;
    primaryIntensityMetric?: string;
  } | null | undefined;
  intensityThresholds?: StructureStepThresholds;
}) {
  const blocks = structure?.structure ?? [];
  if (!blocks.length) return null;

  return (
    <WorkoutStructureBar
      structure={blocks}
      primaryIntensityMetric={structure?.primaryIntensityMetric as PrimaryIntensityMetric | undefined}
      ftpValue={intensityThresholds?.ftp ?? 0}
      ltHrValue={intensityThresholds?.ltHr ?? 0}
      containerWidthPercent={100}
      barHeightPx={28}
      maxHeightPx={28}
    />
  );
}
